import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "moment/locale/ja";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./EventCalendar.css"; // Import custom CSS
import { colors } from "../../common/colors";

// Set moment locale to Japanese
moment.locale("ja");

const localizer = momentLocalizer(moment);

// Custom Toolbar component (same as before)
const CustomToolbar: React.FC<any> = ({ date, onNavigate }) => {
  const currentMonth = moment(date).format("MMMM");
  const currentYear = moment(date).format("YYYY");
  const lastMonth = moment(date).subtract(1, "month").format("MMMM");
  const nextMonth = moment(date).add(1, "month").format("MMMM");

  return (
    <div className="custom-toolbar">
      <button onClick={() => onNavigate("PREV")}>&lt; {lastMonth}</button>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "white",
        }}
      >
        <span>{currentYear}</span>
        <span>{currentMonth}</span>
      </div>
      <button onClick={() => onNavigate("NEXT")}>{nextMonth} &gt;</button>
    </div>
  );
};

// EventCalendar component
const EventCalendar: React.FC<any> = ({
  getSelectedEvent = () => {},
  selectedDate = "",
  dates,
}) => {
  const eventStyleGetter = (event: any) => {
    return {
      backgroundColor: event?.color,
      borderRadius: "5px",
      opacity: 0.8,
      color: "white",
      border: "0px",
      display: "block",
    };
  };

  const dayPropGetter = (date: moment.MomentInput) => {
    const style = {
      backgroundColor:
        selectedDate && moment(date).isSame(selectedDate, "day")
          ? "#86BB57"
          : "white",
      border: "1px solid #ddd",
    };
    return { style };
  };

  const handleEventClick = (event: any) => {
    getSelectedEvent(event);
  };

  return (
    <div
      style={{
        margin: 8,
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: colors.farm_green500,
        borderRadius: 10,
      }}
    >
     <Calendar
        localizer={localizer}
        events={dates}
        culture="ja"
        popup
        startAccessor="start"
        endAccessor="end"
        style={{
          height: 400,
          position: "relative", // Ensures proper stacking
          overflow: "hidden", // Prevent unwanted overflow
        }}
        views={["month"]}
        components={{
          toolbar: CustomToolbar,
        }}
        eventPropGetter={eventStyleGetter} // Apply custom styles to events
        onSelectEvent={handleEventClick} // Handle event click
        dayPropGetter={dayPropGetter}
      />

    </div>
  );
};

export default EventCalendar;
